module.exports = __webpack_public_path__ + "static/media/ба.9fc94f13.mp3";